import React, { FC } from 'react'

export interface AmountByPersonProps {
  name: string
  assigned: number
  billed: number
  total: string
}

export const AmountByPerson: FC<AmountByPersonProps> = ({ name, assigned, billed, total }) => {
  return billed > 0 ? (
    <div className="flex items-center justify-between">
      <div className="flex flex-col">
        <span className="text-gray-700">{name}</span>
        <span className="text-sm text-gray-400">
          {assigned} items assigned, {billed} items billed
        </span>
      </div>
      <span className="font-medium">{total}</span>
    </div>
  ) : null
}
